import Service from "../Service";

export default class LookupService extends Service{
    constructor(){
        super(true, "lookup");
        this.service = 'lookup';
    }

    apiFetch(api, cb){
        return this.request(this.service + "/" + api, null, cb);
    }

    getClinics(cb){
        return this.apiFetch("clinics", cb);
    }

    getCountries(cb){
        return this.apiFetch("countries", cb);
    }

    getAppTypes(cb){
        return this.apiFetch("appointment-type", cb);
    }

    getProvinces(cb){
        return this.apiFetch("province", cb);
    }

    getHowHear(cb){
        return this.apiFetch("how-hear", cb);
    }
}


// WEBPACK FOOTER //
// ./src/api/services/LookupService.js